

export const errorHandlingForLogin = (errorMessage) => {
    if(errorMessage.includes('wrong-password') || errorMessage.includes('invalid-credential')){
        return "auth-errors.loginError.wrong-password"
    }
    else if(errorMessage.includes("user-not-found")) {
        return "auth-errors.loginError.user-not-found"
    }
    else if(errorMessage.includes("user-disabled")){
        return "auth-errors.loginError.user-disabled"
    }
    else if(errorMessage.includes("email-not-verified")){
        return "auth-errors.loginError.email-not-verified"
    }
    else
    {
        return "auth-errors.loginError.other-login"
    }
}

export const errorHandlingForRegister = (errorMessage) => {
    if(errorMessage.includes('username-already-in-use')){
        return "auth-errors.registrationError.username-already-in-use"
    }
    if(errorMessage.includes('email-already-in-use')){
        return "auth-errors.registrationError.email-already-in-use"
    }
    else if(errorMessage.includes("invalid-email")) {
        return "auth-errors.registrationError.invalid-email"
    } else if(errorMessage.includes("weak")){
        return "auth-errors.registrationError.weak-password"
    } 
    else if(errorMessage.includes("operation-not-allowed")){
        return "auth-errors.registrationError.operation-not-allowed"
    }
    else{
        return "auth-errors.registrationError.other-register"
    }
}

// Example Usage:

// import React, { useState } from 'react';
// import { errorHandlingForLogin, errorHandlingForRegister } from './authErrorHandling';
// 
// function AuthComponent() {
//   const [errorMessage, setErrorMessage] = useState('');
// 
//   const handleLogin = () => {
//     // Simulate an error message from a login attempt
//     const loginErrorMessage = 'wrong-password';
//     const loginError = errorHandlingForLogin(loginErrorMessage);
//     setErrorMessage(loginError);
//   };
// 
//   const handleRegister = () => {
//     // Simulate an error message from a registration attempt
//     const registerErrorMessage = 'email-already-in-use';
//     const registerError = errorHandlingForRegister(registerErrorMessage);
//     setErrorMessage(registerError);
//   };
// 
//   return (
//     <div>
//       <button onClick={handleLogin}>Login</button>
//       <button onClick={handleRegister}>Register</button>
//       {errorMessage && <p>{errorMessage}</p>}
//     </div>
//   );
// }
// 
// export default AuthComponent;
